import { action, props } from 'ts-action';
import { SkipHistory } from '../../undo/actions/undo.actions';

export const stop = action('[Ruler] stop');

export const setBoundary = action(
  '[Ruler] setBoundary',
  props<{ boundary: 'start' | 'end'; timestamp?: number }>(),
);

export const setMoving = action(
  '[Ruler] setMoving',
  props<{ timestamp: number }>(),
);

export const setTimestamp = action(
  '[Ruler] setTimestamp',
  props<{ timestamp: number } & SkipHistory>(),
);

export const setRange = action(
  '[Ruler] setRange',
  props<{ start: number; end: number } & SkipHistory>(),
);
